import { render, staticRenderFns } from "./TemplateDetailView.vue?vue&type=template&id=767c0414&scoped=true&"
import script from "./TemplateDetailView.vue?vue&type=script&lang=ts&"
export * from "./TemplateDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c0414",
  null
  
)

export default component.exports